import { del, get, post, put } from "./api_helper"
import * as url from "./url_helper"

export const LoginUser = data => post(url.LOGIN, data)

export const GetPermissions = _ => get(url.PERMISSIONS)

export const RegisterUser = data => post(url.REGISTER, data)

export const GetCaptchaChallenge = _ => get(url.CAPTCHA_CHALLENGE)

export const ConfirmEmail = token => post(url.CONFIRM_EMAIL + "/" + token)

export const CreateUser = data => post(url.USERS, data)

export const UpdateUser = data => put(url.USERS, data)

export const ResetPassword = data => post(url.RESET_PASSWORD, data)

export const ChangePassword = (data, token) =>
  post(url.RESET_PASSWORD + "/" + token, data)

export const ChangeEmail = data => post(url.CHANGE_EMAIL, data)

export const ChangeEmailConfirmation = token =>
  post(url.CHANGE_EMAIL_CONFIRMATION + "/" + token)

export const DeleteUser = id => del(url.DELETE_USER + id)

export const DeleteMyAccount = id => del(url.MY_USER)

export const GetUsers = _ => get(url.USERS)

export const GetMyUser = _ => get(url.MY_USER)

export const CreateCompany = data => post(url.COMPANIES, data)
export const SaveTraderSelfDisclosure = data =>
  put(url.COMPANIES + "/selfDisclosure", data)

export const UpdateCompany = data => put(url.COMPANIES, data)

export const UpdateBilling = data => put(url.BILLING, data)

export const RequestUpgrade = data => post(url.UPGRADE, data)

export const RequestDowngrade = _ => post(url.DOWNGRADE)

export const UpdateLogo = data => put(url.UPDATELOGO, data)

export const CreateLocations = data => post(url.LOCATIONS, data)

export const UpdateLocations = data => put(url.LOCATIONS, data)

export const UploadPartList = data => post(url.PART_LIST, data)

export const UpdatePartList = data => put(url.PART_LIST, data)

export const DeletePart = id => del(url.PART_LIST + "/" + id)

export const GetParts = (search, includeTraderArticles) => {
  let u = url.PART_LIST + "?search=" + encodeURIComponent(search)
  if (includeTraderArticles) u += "&includeTraderArticles=true"
  return get(u)
}

export const GetPublicParts = search =>
  get(url.PUBLIC_PART_LIST + "?search=" + search)

export const GetMyParts = search => get(url.MY_PART_LIST)

export const GetPartByID = partID => get(url.PART_LIST + "/" + partID)

export const CheckPartsInOtherCompanies = partNumbers =>
  post(url.PART_LIST + "/check-other-companies", { partNumbers })

export const UploadLogo = file => post(url.UPLOAD_LOGOS, file)

export const UploadChatAttachment = file =>
  post(url.UPLOAD_CHATATTACHMENTS, file)

export const GetMyLocations = _ => get(url.MY_LOCATIONS)

export const GetLocationByID = id => get(url.MY_LOCATIONS + "/" + id)

export const CreateRequest = data => post(url.REQUESTS, data)

export const AcceptRequest = data => post(url.REQUESTS + "/accept", data)

export const DeclineRequest = data => post(url.REQUESTS + "/decline", data)

export const ArchiveRequest = data => post(url.REQUESTS + "/archive", data)

export const GetMyRequests = data => get(url.REQUESTS)

export const GetRequestByID = id => get(url.REQUESTS + "/" + id)

// Part RFQ
export const GetRfqTraders = () => get(url.REQUESTS + "/rfq/traders")

export const CreatePartRfq = data => post(url.REQUESTS + "/part-rfq", data)

export const AssignBrokerTrader = (requestID, traderCompanyID) =>
  post(url.REQUESTS + "/" + requestID + "/broker-trader", { traderCompanyID })

export const CreateMessage = data => post(url.REQUESTS + "/messages", data)

export const MarkMessageAsRead = id =>
  put(url.REQUESTS + "/messages/markasread/" + id)

export const GetUnreadMessages = id => get(url.REQUESTS + "/messages/unread")

export const SavePart = partID => post(url.SAVEDPARTS, { partID })

export const GetSavedParts = _ => get(url.SAVEDPARTS)

export const UploadWatchlist = data => post(url.WATCH_LIST, data)

export const UpdateWatchlistPart = data => put(url.WATCH_LIST, data)

export const DeleteWatchlistPart = id => del(url.WATCH_LIST + "/" + id)

export const GetWatchlist = _ => get(url.WATCH_LIST)

export const CreateRating = data => post(url.RATINGS, data)

export const CreateQCRating = data => post(url.RATINGS + "/qc", data)

export const GetRatingFromComapny = id => get(url.RATINGS + "/" + id)

export const GetAllQCRequests = _ => get(url.QC_REQUESTS)

export const GetQCRequestByID = id => get(url.QC_REQUESTS + "/" + id)

export const GetAllQCTests = _ => get(url.QC_Tests)

export const GetQCLaborsForTest = qc_test_id =>
  get(url.QC_LABORS + "/" + qc_test_id)

export const CreateQCRequest = data => post(url.QC_REQUESTS, data)

export const UploadQCAttachment = file => post(url.UPLOAD_QCATTACHMENTS, file)

export const UploadQCChatAttachment = file =>
  post(url.UPLOAD_QCCHATATTACHMENTS, file)

export const UpdateQCRequest = data => put(url.QC_REQUESTS, data)

export const ResetQCRequest = data =>
  put(url.QC_REQUESTS + "/resendrequest", data)

export const CreateQCComment = data => post(url.QC_COMMENTS, data)

export const GetUnreadQCRequests = id => get(url.QC_REQUESTS + "/open-count")

export const GetPartnerCockpits = _ => get(url.PARTNER_COCKPITS)

export const CreatePartnerCockpit = data => post(url.PARTNER_COCKPITS, data)

export const GetPartnerCockpitDetails = id =>
  get(url.PARTNER_COCKPITS + "/" + id)

export const InviteUserToPartnerCockpit = (cockpitId, email) =>
  post(url.PARTNER_COCKPITS + "/" + cockpitId + "/users", { email })

export const GetPartnerCockpitInvites = cockpitId =>
  get(url.PARTNER_COCKPITS + "/" + cockpitId + "/invites")

export const GetAllRepairRequests = _ => get(url.REPAIR_REQUESTS)

export const GetRepairRequestByID = id => get(url.REPAIR_REQUESTS + "/" + id)

export const CreateRepairRequest = data => post(url.REPAIR_REQUESTS, data)

export const UploadRepairAttachment = file =>
  post(url.UPLOAD_REPAIRATTACHMENTS, file)

export const UploadRepairChatAttachment = file =>
  post(url.UPLOAD_REPAIRCHATATTACHMENTS, file)

export const UpdateRepairRequest = data => put(url.REPAIR_REQUESTS, data)

export const ResetRepairRequest = data =>
  put(url.REPAIR_REQUESTS + "/resendrequest", data)

export const CreateRepairComment = data => post(url.REPAIR_COMMENTS, data)

export const GetUnreadRepairRequests = id =>
  get(url.REPAIR_REQUESTS + "/open-count")

export const GetRepairLabors = _ => get(url.REPAIR_SERVICES)

export const GetRepairLaborByID = id => get(url.REPAIR_SERVICES + "/" + id)

export const CreateRepairLabor = data => post(url.REPAIR_SERVICES, data)

export const UpdateRepairLabor = data => put(url.REPAIR_SERVICES, data)

export const DeleteRepairLabor = id => del(url.REPAIR_SERVICES + "/" + id)

export const CreateRepairRating = data => post(url.RATINGS + "/repair", data)

export const GetRepairLaborsForTest = repair_test_id =>
  get(url.REPAIR_TESTS + "/labors/all")

export const UpdatePartnerCockpitUser = (cockpitId, userId, data) =>
  put(url.PARTNER_COCKPITS + "/" + cockpitId + "/users/" + userId, data)

export const RemovePartnerCockpitUser = (cockpitId, userId) =>
  del(url.PARTNER_COCKPITS + "/" + cockpitId + "/users/" + userId)

export const GetWatchlistEntryById = id => get(url.WATCH_LIST + "/" + id)

export const UploadLOAList = data => post(url.OEMLOA + "/upload", data)

export const SearchPartnerCockpitParts = search =>
  get(url.PARTNER_COCKPITS + "/search/parts?search=" + search)

export const GetLOAById = id => get(url.OEMLOA + "/" + id)

export const GetLOAs = _ => get(url.OEMLOA)

export const UploadLOAAttachment = file =>
  post(url.UPLOAD_OEMLOA_ATTACHMENTS, file)

export const UpdateLOA = data => {
  return put(url.OEMLOA + "/" + data.id, data)
}

export const DeleteLOAAttachment = id => {
  return del(url.OEMLOA + `/${id}/attachment`)
}

export const AcceptPartnerCockpitInvitation = async invitationId => {
  const response = await get(
    url.PARTNER_COCKPITS + "/invites/" + invitationId + "/accept"
  )
  return response.data
}

export const RejectPartnerCockpitInvitation = async invitationId => {
  const response = await get(
    url.PARTNER_COCKPITS + "/invites/" + invitationId + "/reject"
  )
  return response.data
}

export const DeletePartnerCockpit = id => del(url.PARTNER_COCKPITS + "/" + id)

export const DeleteLOA = id => del(url.OEMLOA + "/" + id)

export const SearchDigikeyParts = keyword =>
  get(url.DIGIKEY + "/search?keyword=" + keyword)

export const GetDigikeyQuota = () => get(url.DIGIKEY + "/quota")

export const SearchOctopartParts = keyword =>
  get(url.OCTOPART + "/search?keyword=" + keyword)

export const GetOctopartQuota = () => get(url.OCTOPART + "/quota")

// CPS Programming System API functions
export const GetAllCPSRequests = _ => get(url.CPS_REQUESTS)

export const GetCPSRequestByID = id => get(url.CPS_REQUESTS + "/" + id)

export const CreateCPSRequest = data => post(url.CPS_REQUESTS, data)

export const UpdateCPSRequest = data =>
  put(url.CPS_REQUESTS + "/" + data.id, data)

export const CancelCPSRequest = id =>
  post(url.CPS_REQUESTS_CANCEL + "/" + id + "/cancel")

export const GetUnreadCPSRequests = _ => get(url.CPS_REQUESTS + "/open-count")

export const CreateCPSComment = data =>
  post(url.CPS_REQUESTS + "/" + data.cpsRequestID + "/comments", data)

export const UploadCPSAttachment = file => post(url.UPLOAD_CPSATTACHMENTS, file)

export const UploadCPSChatAttachment = file =>
  post(url.UPLOAD_CPSCHATATTACHMENTS, file)

// CPS Programming System Shipments API functions
export const GetAllShipmentsForCPSRequest = requestId =>
  get(url.CPS_SHIPMENTS + "/request/" + requestId)
export const GetShipmentByID = id => get(url.CPS_SHIPMENTS + "/" + id)
export const CreateShipment = data => post(url.CPS_SHIPMENTS, data)
export const UpdateShipment = data =>
  put(url.CPS_SHIPMENTS + "/" + data.id, data)
export const DeleteShipment = id => del(url.CPS_SHIPMENTS + "/" + id)

// CPS Programming System Production Orders API functions
export const GetAllProductionOrdersForCPSRequest = requestId =>
  get(url.CPS_PRODUCTION_ORDERS + "/request/" + requestId)
export const GetProductionOrderByID = id =>
  get(url.CPS_PRODUCTION_ORDERS + "/" + id)
export const CreateProductionOrder = data =>
  post(url.CPS_PRODUCTION_ORDERS, data)
export const UpdateProductionOrder = data =>
  put(url.CPS_PRODUCTION_ORDERS + "/" + data.id, data)
export const DeleteProductionOrder = id =>
  del(url.CPS_PRODUCTION_ORDERS + "/" + id)

// Trader Requests (Excess Stock Valuation) API functions
export const GetTraderRequests = () => get(url.TRADER_REQUESTS)
export const GetTraderRequestByID = id =>
  get(url.TRADER_REQUESTS + "/" + id)
export const CreateTraderRequest = data => post(url.TRADER_REQUESTS, data)
export const UpdateTraderRequestStatus = (id, status) =>
  put(url.TRADER_REQUESTS + "/" + id + "/status", { status })
export const GetTraderRequestOffers = id =>
  get(url.TRADER_REQUESTS + "/" + id + "/offers")
export const SubmitTraderOffer = (id, data) =>
  post(url.TRADER_REQUESTS + "/" + id + "/offers", data)
export const UpdateTraderOffer = (requestId, offerId, data) =>
  put(url.TRADER_REQUESTS + "/" + requestId + "/offers/" + offerId, data)
export const SelectTraderOffer = (requestId, offerId, partIds) =>
  post(
    url.TRADER_REQUESTS + "/" + requestId + "/offers/" + offerId + "/select",
    partIds ? { selectedPartIDs: partIds } : {}
  )
export const GetTraderRequestMessages = (requestId) =>
  get(url.TRADER_REQUESTS + "/" + requestId + "/messages")
export const SendTraderRequestMessage = (requestId, data) =>
  post(url.TRADER_REQUESTS + "/" + requestId + "/messages", data)
